import { useContext, useLayoutEffect, useMemo } from "react";
import { useParams } from "react-router-dom";

import { useSettledOrganisationContext } from "../auth/use-organisation";
import { useSubAccountIds } from "../auth/use-sub-account-tree";
import { UserContext } from "../auth/user-context";
import { isEmployeeInternal } from "../auth/user-utils";
import { setViewedAccount, toViewedAccount } from "./viewed-account";

/** Keeps `addViewedAccount` pointed at the customer the current route shows. */
export const ViewedAccountTracker = (): null => {
  const { customerId } = useParams();
  const { user, hasPermission } = useContext(UserContext);
  const organisation = useSettledOrganisationContext();
  const subAccountIds = useSubAccountIds({ isEnabled: Boolean(customerId) });
  const activeAccountId = user?.activeAccount.accountId;
  const isInternal = isEmployeeInternal(hasPermission);

  const viewedAccount = useMemo(
    () =>
      activeAccountId === undefined
        ? undefined
        : toViewedAccount({ organisation, activeAccountId, subAccountIds, isEmployeeInternal: isInternal }),
    [organisation, activeAccountId, subAccountIds, isInternal]
  );

  // A layout effect, so the account is set before children's passive effects track actions.
  useLayoutEffect(() => {
    setViewedAccount(viewedAccount);
    return () => setViewedAccount(undefined);
  }, [viewedAccount]);

  return null;
};
